import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterService } from '../../account/register/register.service';
import { LoginService } from '../../core/login/login.service';
import { AccountService } from '../../core/auth/account.service';
import { TrackerService } from '../../core/tracker/tracker.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../account/register/register.service";
import * as i4 from "../../core/login/login.service";
import * as i5 from "../../core/auth/account.service";
import * as i6 from "../../core/tracker/tracker.service";
import * as i7 from "../../shared/language/language-selector/language-selector.component";
import * as i8 from "../../shared/support/support-dropdown.component";
import * as i9 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/forms";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "@angular/common";
import * as i13 from "../../shared/password-strength-meter/password-strength-meter.component";
import * as i14 from "../../shared/consent-text/consent-text.component";
import * as i15 from "@ngx-translate/core";
function RegisterZimbabweComponent_div_21_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 21);
} }
function RegisterZimbabweComponent_div_21_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterZimbabweComponent_div_21_fa_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 21);
} }
function RegisterZimbabweComponent_div_21_fa_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterZimbabweComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵelementStart(2, "p", 20);
    i0.ɵɵtemplate(3, RegisterZimbabweComponent_div_21_fa_icon_3_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(4, RegisterZimbabweComponent_div_21_fa_icon_4_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(5, "span", 52);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 53);
    i0.ɵɵelementStart(8, "p", 54);
    i0.ɵɵtemplate(9, RegisterZimbabweComponent_div_21_fa_icon_9_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(10, RegisterZimbabweComponent_div_21_fa_icon_10_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(11, "span", 55);
    i0.ɵɵelement(12, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.isLetterNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isLetterNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.isMax20);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMax20);
} }
function RegisterZimbabweComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelement(1, "span", 58);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function RegisterZimbabweComponent_fa_icon_44_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 59);
    i0.ɵɵlistener("click", function RegisterZimbabweComponent_fa_icon_44_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onTogglePassword(ctx_r12.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterZimbabweComponent_fa_icon_45_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 60);
    i0.ɵɵlistener("click", function RegisterZimbabweComponent_fa_icon_45_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onTogglePassword(ctx_r14.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterZimbabweComponent_fa_icon_51_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 59);
    i0.ɵɵlistener("click", function RegisterZimbabweComponent_fa_icon_51_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.onTogglePassword(ctx_r16.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterZimbabweComponent_fa_icon_52_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 60);
    i0.ɵɵlistener("click", function RegisterZimbabweComponent_fa_icon_52_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onTogglePassword(ctx_r18.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterZimbabweComponent_div_53_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 21);
} }
function RegisterZimbabweComponent_div_53_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterZimbabweComponent_div_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵelementStart(2, "p", 20);
    i0.ɵɵtemplate(3, RegisterZimbabweComponent_div_53_fa_icon_3_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(4, RegisterZimbabweComponent_div_53_fa_icon_4_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(5, "span", 61);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.passwordsMatch);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.passwordsMatch);
} }
export class RegisterZimbabweComponent {
    constructor(activatedRoute, ngbModal, registerService, loginService, accountService, elementRef, router, trackerService) {
        this.activatedRoute = activatedRoute;
        this.ngbModal = ngbModal;
        this.registerService = registerService;
        this.loginService = loginService;
        this.accountService = accountService;
        this.elementRef = elementRef;
        this.router = router;
        this.trackerService = trackerService;
        this.generatedUsername = '';
        this.isLetterNumber = true;
        this.isMax20 = true;
        this.isMin8 = false;
        this.passwordsMatch = true;
        this.toggle = '';
        this.focusClass = 'mb-2';
        this.TOGGLE_USERNAME = 'TOGGLE_USERNAME';
        this.TOGGLE_PASSWORD = 'TOGGLE_PASSWORD';
        this.TOGGLE_CONFIRM = 'TOGGLE_CONFIRM';
        this.TOGGLE_PHONE = 'TOGGLE_PHONE';
        this.passwordTypeInput = 'password';
        this.confirmTypeInput = 'password';
        this.passwordEyeSlashed = false;
        this.confirmEyeSlashed = false;
        this.TYPE_PASSWORD = 'TYPE_PASSWORD';
        this.TYPE_CONFIRM = 'TYPE_CONFIRM';
        this.ZIMBABWE = 'Zimbabwe';
        this.specialCharacters = new RegExp('^[a-zA-Z0-9]+$');
        this.emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        this.phonePattern = new RegExp('^[0-9]+$');
        this.isUsed = false;
        this.consents = [];
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        if (this.accountService.isAuthenticated()) {
            this.loginService.redirectToHomepage();
        }
        this.generateUsername();
    }
    generateUsername() {
        this.generateUsernameSubscription = this.registerService.generateUsername().subscribe(response => (this.generatedUsername = response));
    }
    onRegister(form) {
        console.log(form.value);
        let login = form.value.login;
        let email = form.value.email.trim();
        let phoneValue = form.value.phone.toString();
        if (phoneValue === null) {
            this.registerService.openAlertModal('register.messages.error.phoneIncomplete');
            return;
        }
        let phoneNumber = '+263' + phoneValue.trim();
        let password = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        let voucherCode = this.activatedRoute.snapshot.queryParamMap.get('voucherCode');
        let country = this.ZIMBABWE;
        let checkbox = form.value.checkbox;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (login.length === 0) {
            this.registerService.openAlertModal('register.messages.error.usernameRequired');
            return;
        }
        if (login.length > 20) {
            this.registerService.openAlertModal('register.messages.error.usernameMaxTwenty');
            return;
        }
        if (!this.specialCharacters.test(login)) {
            this.registerService.openAlertModal('register.messages.error.numberLetterOnly');
            return;
        }
        if (email.length === 0) {
            this.registerService.openAlertModal('register.messages.error.emailRequired');
            return;
        }
        if (!this.emailPattern.test(email)) {
            this.registerService.openAlertModal('register.messages.error.invalidEmail');
            return;
        }
        if (phoneNumber.length < 5) {
            this.registerService.openAlertModal('register.messages.error.phoneRequired');
            return;
        }
        if (phoneNumber.length < 12) {
            this.registerService.openAlertModal('register.messages.error.phoneIncomplete');
            return;
        }
        if (!this.phonePattern.test(phoneNumber.slice(1))) {
            this.registerService.openAlertModal('register.messages.error.invalidPhone');
            return;
        }
        if (password.length < 8) {
            this.registerService.openAlertModal('register.messages.error.atLeast8');
            return;
        }
        if (confirmPassword !== password) {
            this.registerService.openAlertModal('register.messages.error.doNotMatch');
            return;
        }
        // if (!this.specialCharacters.test(password)) {
        //   this.registerService.openAlertModal('register.messages.error.numberLetterOnlyPassword');
        //   return;
        // }
        if (!checkbox) {
            this.registerService.openAlertModal('register.messages.error.agreeTerms');
            return;
        }
        let registrationData = { login, email, phoneNumber, password, voucherCode, country, timezone, consents: this.consents };
        this.registrationSubscription = this.registerService.save(registrationData).subscribe(response => {
            if (response === "Voucher code doesn't exist!") {
                this.registerService.openAlertModal('register.messages.error.noVoucherCode');
                return;
            }
            if (response === 'There are no more usages left for the voucher code!') {
                this.registerService.openAlertModal('register.messages.error.noUsageVoucherCode');
                return;
            }
            if (response === 'Voucher code expired!') {
                this.registerService.openAlertModal('register.messages.error.voucherCodeExpired');
                return;
            }
            if (response === "Voucher code doesn't run!") {
                this.registerService.openAlertModal('register.messages.error.noRunVoucherCode');
                return;
            }
            if (response === 'OK') {
                this.trackerService.sendActivity("registration_completed");
                let request = { email, password, rememberMe: true };
                this.loginSubscription = this.loginService.login(request).subscribe(() => {
                    this.router.navigate(['/onboarding']).then();
                }, error => console.log(error));
            }
        }, response => {
            let errorKey = JSON.parse(response.error).errorKey;
            if (errorKey === 'userexists' || errorKey === 'emailexists' || errorKey === 'phonenumberexists') {
                this.isUsed = true;
                this.registerService.openAlertModal('register.messages.error.' + errorKey);
                return;
            }
        });
    }
    modalNavigate(url) {
        this.router.navigate([url]).then(response => console.log(response));
    }
    focusInOut(toggleField, focusIn) {
        this.toggle = focusIn ? toggleField : '';
        this.focusClass = focusIn ? 'mb-2' : '';
    }
    passwordCheck(form) {
        let firstPassword = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        this.isMin8 = firstPassword.length >= 8;
        this.passwordsMatch = firstPassword === confirmPassword;
    }
    onTogglePassword(type) {
        if (type === this.TYPE_PASSWORD) {
            this.passwordEyeSlashed = !this.passwordEyeSlashed;
            this.passwordTypeInput === 'text' ? (this.passwordTypeInput = 'password') : (this.passwordTypeInput = 'text');
        }
        else if (type === this.TYPE_CONFIRM) {
            this.confirmEyeSlashed = !this.confirmEyeSlashed;
            this.confirmTypeInput === 'text' ? (this.confirmTypeInput = 'password') : (this.confirmTypeInput = 'text');
        }
    }
    updateConsents(consent) {
        this.consents = this.consents.filter(c => c.name !== consent.name);
        this.consents.push(consent);
    }
    setPasswordText(form) {
        this.passwordText = form.value.password.trim();
    }
    ngOnDestroy() {
        if (this.registrationSubscription) {
            this.registrationSubscription.unsubscribe();
        }
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.generateUsernameSubscription) {
            this.generateUsernameSubscription.unsubscribe();
        }
    }
}
RegisterZimbabweComponent.ɵfac = function RegisterZimbabweComponent_Factory(t) { return new (t || RegisterZimbabweComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.RegisterService), i0.ɵɵdirectiveInject(i4.LoginService), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i6.TrackerService)); };
RegisterZimbabweComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegisterZimbabweComponent, selectors: [["register-zimbabwe"]], decls: 65, vars: 46, consts: [[1, "navbar", "navbar-dark", "d-flex", "justify-content-end"], [1, "row"], [1, "float-right", "pl-2", "pr-2"], [1, "page", 2, "background-color", "white"], [1, "page-single", 2, "background-color", "white", "border-radius", "20px"], [1, "container-fluid"], [1, "row", "fadeIn", "animated"], [1, "offset-sm-2", "col-sm-8", "offset-md-3", "col-md-6", "offset-lg-3", "col-lg-6", "offset-xl-4", "col-xl-4"], ["id", "inuka-header-default", 2, "background-color", "#eef6f4", "text-align", "center", "margin-top", "10px", "border-radius", "6px"], ["id", "FB-inuka-logo"], ["src", "../../../../content/images/inuka/FB-inuka-small.png", "alt", "FB-inuka-small image", 2, "height", "200px"], ["jhiTranslate", "register.header.chooseCoach", 1, "m-2", 2, "font-weight", "bold", "color", "black"], [3, "ngSubmit"], ["registrationForm", "ngForm"], ["id", "username-div", 2, "position", "relative"], ["type", "text", "id", "username", "name", "login", "required", "", 1, "form-control", 2, "border-radius", "6px", 3, "ngModel", "placeholder", "ngModelChange", "focusin", "focusout"], ["icon", "undo", 1, "undo", 3, "click"], ["class", "row mt-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "col-12", 2, "float", "left", "padding", "0 10px 0 20px"], [2, "float", "left", "margin-bottom", "0!important"], ["icon", "check", 1, "check"], ["jhiTranslate", "register.paragraph.confidentialIdentity", 1, "indicator-text"], [1, "form-group", "mb-2"], ["type", "text", "id", "email", "name", "email", "ngModel", "", "required", "", 1, "form-control", 3, "placeholder"], [1, "input-group", "mb-2"], [1, "input-group-text"], ["type", "number", "id", "phone", "name", "phone", "ngModel", "", "required", "", 3, "placeholder", "focusin", "focusout"], ["class", "row phone-indicator mt-2", "style", "padding: 0 10px 0 20px; font-size: calc(10px + 0.3vw);", 4, "ngIf"], ["hidden", "", 1, "input", "group", "mb-2"], ["type", "text", "id", "voucher-code", 1, "form-control", 3, "placeholder"], ["id", "new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "new-password", "name", "password", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "ngModelChange"], ["class", "eye", "icon", "eye", 3, "click", 4, "ngIf"], ["class", "eye", "icon", "eye-slash", 3, "click", 4, "ngIf"], [3, "password"], ["id", "confirmed-new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "confirmed-new-password", "name", "confirmPassword", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "keyup"], [1, "row", "mt-2", "mb-3", 2, "padding-left", "18px"], [1, "form-group", "col-1", 2, "padding-right", "0!important"], ["id", "confirm-checkbox", "type", "checkbox", "ngModel", "", "name", "checkbox", "required", "", 1, "form-control", "customcheck", "checkmark", "mb-2", 2, "color", "#44A38D"], [1, "col-11", 2, "font-size", "12px", "padding", "0!important"], ["name", "inuka-terms", 3, "onChange"], ["id", "registrationError", 1, "col-12"], [1, "col-12"], ["id", "sign-me-up-button", "type", "submit", "jhiTranslate", "register.button.signMeUp", 1, "btn", "btn-gradient-primary", "btn-block", "font-weight-bold"], [2, "margin", "10px"], ["jhiTranslate", "register.paragraph.haveAccount", 2, "text-align", "center", "margin-bottom", "0"], [1, "row", "mt-2"], [1, "col-6", 2, "float", "left", "padding", "0 10px 0 20px"], ["class", "check", "icon", "check", 4, "ngIf"], ["class", "times", "icon", "times", 4, "ngIf"], ["jhiTranslate", "register.paragraph.lettersNumbers", 1, "indicator-text"], [1, "col-6", 2, "padding", "0 10px 0 10px"], [2, "text-align", "center", "margin-bottom", "0!important"], ["jhiTranslate", "register.paragraph.maxChar", 1, "indicator-text"], ["icon", "times", 1, "times"], [1, "row", "phone-indicator", "mt-2", 2, "padding", "0 10px 0 20px", "font-size", "calc(10px + 0.3vw)"], ["jhiTranslate", "register.paragraph.phone", 1, "username-indicator"], ["icon", "eye", 1, "eye", 3, "click"], ["icon", "eye-slash", 1, "eye", 3, "click"], ["jhiTranslate", "register.paragraph.passwordsMatch", 1, "indicator-text", 2, "padding-left", "3px"]], template: function RegisterZimbabweComponent_Template(rf, ctx) { if (rf & 1) {
        const _r22 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "nav", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "language-selector");
        i0.ɵɵelement(3, "support-dropdown", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelement(11, "img", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "h3", 11);
        i0.ɵɵelement(13, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "br");
        i0.ɵɵelementStart(15, "form", 12, 13);
        i0.ɵɵlistener("ngSubmit", function RegisterZimbabweComponent_Template_form_ngSubmit_15_listener() { i0.ɵɵrestoreView(_r22); const _r0 = i0.ɵɵreference(16); return ctx.onRegister(_r0); });
        i0.ɵɵelementStart(17, "div", 14);
        i0.ɵɵelementStart(18, "input", 15);
        i0.ɵɵlistener("ngModelChange", function RegisterZimbabweComponent_Template_input_ngModelChange_18_listener($event) { return ctx.generatedUsername = $event; })("focusin", function RegisterZimbabweComponent_Template_input_focusin_18_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, true); })("focusout", function RegisterZimbabweComponent_Template_input_focusout_18_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, false); });
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "fa-icon", 16);
        i0.ɵɵlistener("click", function RegisterZimbabweComponent_Template_fa_icon_click_20_listener() { return ctx.generateUsername(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, RegisterZimbabweComponent_div_21_Template, 13, 4, "div", 17);
        i0.ɵɵelementStart(22, "div", 18);
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵelementStart(24, "p", 20);
        i0.ɵɵelement(25, "fa-icon", 21);
        i0.ɵɵelement(26, "span", 22);
        i0.ɵɵelement(27, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 23);
        i0.ɵɵelement(29, "input", 24);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 25);
        i0.ɵɵelementStart(32, "div");
        i0.ɵɵelementStart(33, "div", 26);
        i0.ɵɵtext(34, "+263");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "input", 27);
        i0.ɵɵlistener("focusin", function RegisterZimbabweComponent_Template_input_focusin_35_listener() { return ctx.focusInOut(ctx.TOGGLE_PHONE, true); })("focusout", function RegisterZimbabweComponent_Template_input_focusout_35_listener() { return ctx.focusInOut(ctx.TOGGLE_PHONE, false); });
        i0.ɵɵpipe(36, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(37, RegisterZimbabweComponent_div_37_Template, 3, 0, "div", 28);
        i0.ɵɵelementStart(38, "div", 29);
        i0.ɵɵelement(39, "input", 30);
        i0.ɵɵpipe(40, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 31);
        i0.ɵɵelementStart(42, "input", 32);
        i0.ɵɵlistener("focusin", function RegisterZimbabweComponent_Template_input_focusin_42_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, true); return ctx.showPasswordMeter = true; })("focusout", function RegisterZimbabweComponent_Template_input_focusout_42_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, false); return ctx.showPasswordMeter = false; })("ngModelChange", function RegisterZimbabweComponent_Template_input_ngModelChange_42_listener() { i0.ɵɵrestoreView(_r22); const _r0 = i0.ɵɵreference(16); ctx.passwordCheck(_r0); return ctx.setPasswordText(_r0); });
        i0.ɵɵpipe(43, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(44, RegisterZimbabweComponent_fa_icon_44_Template, 1, 0, "fa-icon", 33);
        i0.ɵɵtemplate(45, RegisterZimbabweComponent_fa_icon_45_Template, 1, 0, "fa-icon", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div");
        i0.ɵɵelement(47, "password-strength-meter-component", 35);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 36);
        i0.ɵɵelementStart(49, "input", 37);
        i0.ɵɵlistener("focusin", function RegisterZimbabweComponent_Template_input_focusin_49_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, true); })("focusout", function RegisterZimbabweComponent_Template_input_focusout_49_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, false); })("keyup", function RegisterZimbabweComponent_Template_input_keyup_49_listener() { i0.ɵɵrestoreView(_r22); const _r0 = i0.ɵɵreference(16); return ctx.passwordCheck(_r0); });
        i0.ɵɵpipe(50, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(51, RegisterZimbabweComponent_fa_icon_51_Template, 1, 0, "fa-icon", 33);
        i0.ɵɵtemplate(52, RegisterZimbabweComponent_fa_icon_52_Template, 1, 0, "fa-icon", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(53, RegisterZimbabweComponent_div_53_Template, 7, 2, "div", 17);
        i0.ɵɵelementStart(54, "div", 38);
        i0.ɵɵelementStart(55, "div", 39);
        i0.ɵɵelement(56, "input", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(57, "div", 41);
        i0.ɵɵelementStart(58, "consent-text", 42);
        i0.ɵɵlistener("onChange", function RegisterZimbabweComponent_Template_consent_text_onChange_58_listener($event) { return ctx.updateConsents($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(59, "div", 1);
        i0.ɵɵelement(60, "div", 43);
        i0.ɵɵelementStart(61, "div", 44);
        i0.ɵɵelement(62, "button", 45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(63, "hr", 46);
        i0.ɵɵelement(64, "p", 47);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(17);
        i0.ɵɵclassMapInterpolate1("form-group ", ctx.focusClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 34, "register.placeholder.username"));
        i0.ɵɵproperty("ngModel", ctx.generatedUsername);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_USERNAME);
        i0.ɵɵadvance(8);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 36, "register.placeholder.email"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("input-group-prepend ", ctx.focusClass, "");
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(36, 38, "register.placeholder.phoneNumber"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_PHONE);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 40, "register.placeholder.voucherCode"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.passwordTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(43, 42, "register.placeholder.password"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.showPasswordMeter ? "" : "d-none");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("password", ctx.passwordText);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.confirmTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(50, 44, "register.placeholder.repeatPassword"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_CONFIRM);
    } }, directives: [i2.NgbNavbar, i7.LanguageSelectorComponent, i8.SupportDropdownComponent, i9.JhiTranslateDirective, i10.ɵNgNoValidate, i10.NgControlStatusGroup, i10.NgForm, i10.DefaultValueAccessor, i10.RequiredValidator, i10.NgControlStatus, i10.NgModel, i11.FaIconComponent, i12.NgIf, i10.NumberValueAccessor, i13.PasswordStrengthMeterComponent, i10.CheckboxControlValueAccessor, i10.CheckboxRequiredValidator, i14.ConsentTextComponent], pipes: [i15.TranslatePipe], styles: [".consent-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif;font-style:normal;font-size:11px;line-height:140% !important;color:#0a4a3a}"] });
